<ui-badge *ngIf="visible" class="margin-left-1" [type]="badgeType">{{
    label | appTranslateOptions: locationTypeDetails | uppercase
}}</ui-badge>
